/**
 * When an input event happened, in the timebase of `now` (performance.now() in the
 * browser). `event.timeStamp` is exactly that in every current browser; anything that does
 * not look like it (0, an epoch time from an old engine, a clock that runs elsewhere such as
 * the dev harness's time warp) falls back to `now`.
 */
export function eventTime(event: Event, now: number): number {
  const stamp = event.timeStamp;
  // Events are dispatched a little after they happen, never before and never seconds later.
  return Number.isFinite(stamp) && stamp <= now + 1 && stamp >= now - 1000 ? stamp : now;
}
